<template>
	<div class="percentage">
		<div class="abs" v-for="item in num" :key="item">
			<div class="sub"></div>
		</div>
		<div class="inner center"></div>
		<div class="center data column-center">
			<div>
				<span class="num">0</span>
				<span>%</span>
			</div>
			<p>实时磨损率</p>
		</div>
	</div>
</template>

<script>
	export default {
		name: "Percentage",
		data(){
			return {
				num: 100,
				green: 0,
			}
		},
		mounted() {
			let divs = document.querySelectorAll(".abs");

			let deg = 0
			let step = 360 / this.num
			for (let i = 0; i < this.num; i++) {
				divs[i].style.transform = `rotate(${deg}deg)`
				deg += step

				if(i <= this.green){
					divs[i].children[0].style.backgroundColor = "#68D86A"
				}
			}

		}
	}
</script>

<style scoped lang="less">
.percentage {
	position: relative;
	border-radius: 50%;
	overflow: hidden;
	width: 100%;
	height: 100%;

	.abs {
		width: 100%;
		height: 100%;
		position: absolute;
		left: 0;
		top: 0;
		transform: rotate(0);
	}

	.sub {
		.w(2);
		.h(30);
		background-color: #E5E9EF;
		margin: 0 auto;
	}
	.inner {
		width: 70%;
		height: 70%;
		border-radius: 50%;
		border: 20rem solid #F0F3F6;

	}

	.center{
		position: absolute;
		left: 50%;
		top: 50%;
		transform: translate(-50%, -50%);
	}

	.data {

		font-size: 24rem;
		font-weight: 400;
		color: #68D86A;

		.num {
			font-size: 36rem;
			margin-right: 5rem;
		}

		p {
			color: #333333;
			font-size: 16rem;
		}
	}
}
</style>